import React from 'react';
import * as Styles from './StepsStyles';
import StepsList from './StepsList';

interface Props {
  currentStep: number;
}

const Step: React.FC<Props> = ({ currentStep }: Props) => {
  return (
    <Styles.SectionSteps>
      <Styles.StepsContainer>
        <Styles.Logo />
        <StepsList currentStep={currentStep} />
      </Styles.StepsContainer>
    </Styles.SectionSteps>
  );
};

export default Step;
